import { PricingType, PerksPricingType } from '../types';

export const getProductPricing = ({
  pricing,
  shouldDisplayWasPrice,
  perksPricing,
  isPerksMember,
  showPerksPrice,
  shouldHidePerksExclusiveDealsFromNonMembers,
  isPerksEarlyAccess,
  isPerksExclusiveDeal,
}: {
  pricing: PricingType;
  shouldDisplayWasPrice?: boolean;
  perksPricing?: PerksPricingType;
  isPerksMember?: boolean;
  showPerksPrice?: boolean;
  shouldHidePerksExclusiveDealsFromNonMembers?: boolean;
  isPerksEarlyAccess?: boolean;
  isPerksExclusiveDeal?: boolean;
}) => {
  if (!pricing) return;
  const { displayPriceAfterCashback, wasPrice, priceAfterCashback, displayPriceInc, displayWasPrice } = pricing;
  const hasPerksPromotion = isPerksEarlyAccess || isPerksExclusiveDeal;
  const perksPrice =
    isPerksExclusiveDeal && (!shouldHidePerksExclusiveDealsFromNonMembers || isPerksMember)
      ? perksPricing?.displayPriceInc
      : 0;
  let ticketPrice = 0;
  let actualPrice =
    isPerksEarlyAccess && !isPerksExclusiveDeal && isPerksMember ? perksPricing?.displayPriceInc : displayPriceInc;
  if (!hasPerksPromotion && showPerksPrice && isPerksMember && perksPricing?.displayWasPrice) {
    ticketPrice = perksPricing.wasPrice;
    actualPrice = perksPricing.displayPriceInc;
  } else if (!hasPerksPromotion || (isPerksEarlyAccess && !isPerksMember)) {
    if (displayPriceAfterCashback) {
      ticketPrice = displayPriceInc;
      actualPrice = priceAfterCashback ?? 0;
    } else if (showPerksPrice && shouldDisplayWasPrice && isPerksMember) {
      ticketPrice = 0;
    } else if (shouldDisplayWasPrice) {
      ticketPrice = wasPrice ?? 0;
    }
  } else if ((isPerksExclusiveDeal && perksPricing) || (isPerksEarlyAccess && isPerksExclusiveDeal && perksPricing)) {
    if (perksPricing.displayPriceAfterCashback) {
      ticketPrice = displayPriceInc;
    } else if (perksPricing.displayWasPrice && wasPrice) {
      ticketPrice = displayWasPrice ? wasPrice : displayPriceInc;
      actualPrice = displayPriceInc;
    }
  } else if (isPerksEarlyAccess && isPerksMember && perksPricing) {
    if (perksPricing.displayPriceAfterCashback) {
      ticketPrice = perksPricing.displayPriceInc;
    } else if (perksPricing.displayWasPrice) {
      ticketPrice = perksPricing.wasPrice ?? displayPriceInc;
    }
  }
  return {
    ticket: ticketPrice,
    actual: actualPrice ?? displayPriceInc,
    cashback: hasPerksPromotion ? perksPricing?.displayPriceAfterCashback : displayPriceAfterCashback,
    perks: perksPrice,
  };
};
